// MST
import { types, flow, cast } from 'mobx-state-tree'

// Interfaces
import { ICertificationSchemaDropdown } from 'interfaces/back-office/master/certification-schema'
import { ICertificationSchemaGetDropdownAttrs } from 'interfaces/back-office/master/certification-schema/certification-schema-view.interface'
import { ICertificationSchemaApiDropdownResponse } from 'interfaces/back-office/master/certification-schema/certification-schema-api.interface'

// Extensions
import { withHelper_baseResponseDropdownTypesModel } from 'models/extensions/with-helper'
import { withEnvironment } from 'models/extensions/with-environment'

const CertificationSchemaStoreModel = types
  .model('CertificationSchema')
  .props({
    masterCertificationSchema_isLoading: types.optional(types.boolean, false),
    masterCertificationSchema_dropdown: withHelper_baseResponseDropdownTypesModel('CertificationSchemaDropdown'),
  })
  .extend(withEnvironment)
  .actions(self => ({
    masterCertificationSchema_SET_LOADING: (payload: boolean): void => {
      self.masterCertificationSchema_isLoading = payload
    },
    masterCertificationSchema_SET_CERTIFICATION_SCHEMA_DROPDOWN: (payload: ICertificationSchemaDropdown[]): void => {
      self.masterCertificationSchema_dropdown = cast(payload.filter(dropdown => dropdown.value))
    },
    masterCertificationSchema_CLEAR_CERTIFICATION_SCHEMA_DROPDOWN: (): void => {
      self.masterCertificationSchema_dropdown = cast([])
    },
  }))
  .actions(self => ({
    /**
     * @description Fetch certification schema dropdown
     *
     * @param {ICertificationSchemaGetDropdownAttrs} payload
     *
     * @return {any} any
     */
    masterCertificationSchema_fetchCertificationSchemaDropdown: flow(function* (payload: ICertificationSchemaGetDropdownAttrs) {
      self.masterCertificationSchema_SET_LOADING(true)

      const response: ICertificationSchemaApiDropdownResponse =
        yield self.environment.masterCertificationSchemaApi.masterCertificationSchema_getCertificationSchemaDropdown({
          body: payload?.body,
          requestConfig: { ...payload.requestConfig },
        })
      if (response.ok) {
        self.masterCertificationSchema_SET_CERTIFICATION_SCHEMA_DROPDOWN(response.res.data || [])

        // Do when response success
        if (payload?.onSuccess) payload.onSuccess()
      }

      if (!response.ok) {
        // Do when response failed
        if (payload?.onError) payload.onError()
      }

      self.masterCertificationSchema_SET_LOADING(false)
    }),
  }))

export const createCertificationSchemaStoreDefaultModel = () => types.optional(CertificationSchemaStoreModel, {})
